// @flow

import * as React from 'react';
import { Collapse, CardBody, Card } from 'reactstrap';
import ReactAI from 'react-appinsights';

type Props = {
    text: string,
    helpHtml?: string
};

type HelpState = {
    showHelp: boolean
}

class TableHeader extends React.Component<Props, HelpState> {

    constructor(props: Props) {
        super(props);
        this.state = { showHelp: false };
    }

    toggleHelp() {
        this.setState({ showHelp: !this.state.showHelp });
    }

    render() {

        let upDownClass = this.state.showHelp ? "fa-angle-up" : "fa-angle-down";

        return (<div className="table-header">
                    <div className="header-and-symbols">
                        <span>{this.props.text}</span>
                        { this.props.helpHtml && <span className="help-symbols print-hide" onClick={this.toggleHelp.bind(this)}>
                                <span>i</span>
                            </span> }
                    </div>
                    <div className="help-box">
                        <Collapse isOpen={this.state.showHelp}>
                            <span dangerouslySetInnerHTML={{ __html: this.props.helpHtml }} />
                        </Collapse>
                    </div>
                </div>
        );

    }

}

export default ReactAI.withTracking(TableHeader); 


// WEBPACK FOOTER //
// ./src/components/TableHeader.js